import { useLocale } from '@/hooks/useLocale';
import { LegalPageLayout } from '@/components/LegalPageLayout';
import { getLegalBundle } from '@/data/legal';

export default function Disclaimer() {
  const { lang } = useLocale();
  return <LegalPageLayout docType="disclaimer" bundle={getLegalBundle(lang)} />;
}
